// extracted by mini-css-extract-plugin
export default {"loaderContainer":"ScreenLoader_loaderContainer__g9wlg","overlay":"ScreenLoader_overlay__8ELd3"};